export const regex = {
  phone: new RegExp(
    /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
  ),
  zipCode: new RegExp(
    /^(\d{5}([-]\d{4})?)$/
  )
}

